import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../views/Index.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Index',
    component: Index
  },
  {
    path: '/whoUs',
    name: 'WhoUs',
    component: () => import(/* webpackChunkName: "about" */ '../views/WhoUs.vue')
  },
  {
    path: '/whoUs2',
    name: 'WhoUs2',
    component: () => import(/* webpackChunkName: "about" */ '../views/WhoUs2.vue')
  },
  {
    path: '/story',
    name: 'Story',
    component: () => import(/* webpackChunkName: "about" */ '../views/Story.vue')
  },
  {
    path: '/story2',
    name: 'Story2',
    component: () => import(/* webpackChunkName: "about" */ '../views/Story2.vue')
  },
  {
    path: '/growUp',
    name: 'growUp',
    component: () => import(/* webpackChunkName: "about" */ '../views/GrowUp.vue')
  },
  {
    path: '/growUp2',
    name: 'growUp2',
    component: () => import(/* webpackChunkName: "about" */ '../views/GrowUp2.vue')
  },
  {
    path: '/service',
    name: 'service',
    component: () => import(/* webpackChunkName: "about" */ '../views/Service.vue')
  },
  {
    path: '/service2',
    name: 'service2',
    component: () => import(/* webpackChunkName: "about" */ '../views/Service2.vue')
  },
  {
    path: '/partner',
    name: 'Partner',
    component: () => import(/* webpackChunkName: "about" */ '../views/Partner.vue')
  },
  {
    path: '/partner2',
    name: 'Partner2',
    component: () => import(/* webpackChunkName: "about" */ '../views/Partner2.vue')
  },
  {
    path: '/contactUS',
    name: 'ContactUs',
    component: () => import(/* webpackChunkName: "about" */ '../views/ContactUs.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
